module.exports = __webpack_public_path__ + "static/media/sakemaki.a75ca98d.png";